import { handleGeneralError } from 'src/utils/error-handler';
import { enqueueSnackbar } from 'notistack';
import { ERROR } from 'src/utils/constant';
import { fDate } from 'src/utils/format-time';
import { SCHOOL_ID } from 'src/config-global';

export function convertToPayload(data: any) {
  return {
    readerCode: data.code,
    receiveDate: fDate(data.receiveDate),
    bookIds: data.books,
    schoolId: SCHOOL_ID,
  };
}
/* ------- XỬ LÝ LỖI SAU KHI SUBMIT FORM ------ */
const fields: any = {
  readerCode: 'Tên bạn đọc',
  receiveDate: 'Ngày sinh',
  bookIds: 'Địa chỉ',
};
const fieldAlias: any = {
  readerCode: 'code',
  receiveDate: 'receiveDate',
  bookIds: 'books',
};
const BORROW_BOOK_ERROR = {
  ...ERROR,
  RESOURCE_HAS_EXPIRED: 'RESOURCE_HAS_EXPIRED',
  BOOK_IS_BORROWED: 'BOOK_IS_BORROWED',
  EXCEEDED_MAX_BOOKING_QUANTITY: 'EXCEEDED_MAX_BOOKING_QUANTITY',
};
export function handleError(error: any, setError: any, setApiError: any) {
  error.details?.forEach((detail: any) => {
    const field = fields[detail?.field];
    const alias = detail?.field in fieldAlias ? fieldAlias[detail?.field] : detail?.field;

    switch (detail.code) {
      case BORROW_BOOK_ERROR.RESOURCE_HAS_EXPIRED:
        enqueueSnackbar(detail.message, { variant: 'error' });
        setError(alias, { type: 'custom', message: detail.message });
        break;

      case BORROW_BOOK_ERROR.BOOK_IS_BORROWED:
        enqueueSnackbar(detail.message, { variant: 'error' });
        setError(alias, { type: 'custom', message: detail.message });
        if (detail?.bookIds && setApiError) setApiError(detail.bookIds);
        break;

      case BORROW_BOOK_ERROR.EXCEEDED_MAX_BOOKING_QUANTITY:
        enqueueSnackbar(detail.message, { variant: 'error' });
        break;

      default:
        handleGeneralError(field, alias, detail, setError);
        break;
    }
  });
}
